var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min")
};

var wrapText = require("./lib/wrapText");
var makeTranslate = require("./lib/makeTranslate");
var { isMobile, isDesktop } = require("./lib/breakpoints");
var classify = require("./lib/classify");
var debounce = require("./lib/debounce");

var fmtYearAbbrev = d => (d.getFullYear() + "").slice(-2);
var fmtYearFull = d => d.getFullYear();

var DATA = require("../../data/herding.sheet.json");
var dataSeries = [];

var formatData = function() {
  DATA.forEach(function(d) {
    d.date = new Date(d.date, 0, 1);
  });

  // Restructure tabular data for easier charting.
  for (var column in DATA[0]) {
    if (column == "date") continue;
    else {
      dataSeries.push({
        name: column,
        values: DATA.map(d => ({
          date: d.date,
          amt: +d[column] * 100
        }))
      });
    }
  }
};

var dateColumn = "date";
var valueColumn = "amt";

var aspectWidth = 4;
var aspectHeight = 3;

if(isDesktop.matches){
  aspectWidth = 16;
  aspectHeight = 9;
}

var margins = {
  top: 10,
  right: 100,
  bottom: 50,
  left: 40
};

var ticksX = 10;
var ticksY = 10;
var roundTicksFactor = 10;

// Mobile
if (isMobile.matches) {
  ticksX = 5;
  ticksY = 5;
  
}

formatData();
renderHerding();
window.addEventListener("resize", debounce(renderHerding));

function renderHerding() {
  var container = document.querySelector(".graphic.herding .container");

  // Calculate actual chart dimensions
  var chartWidth = container.offsetWidth - margins.left - margins.right;
  var chartHeight =
    Math.ceil((container.offsetWidth * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  //clear for redraw
  var containerElement = d3.select(container);
  containerElement.html("");

  var dates = dataSeries[0].values.map(d => d.date);
  var extent = [dates[0], dates[dates.length - 1]];

  var xScale = d3
    .scaleTime()
    .domain(extent)
    .range([0, chartWidth]);

  var values = dataSeries.reduce(
    (acc, d) => acc.concat(d.values.map(v => v[valueColumn])),
    []
  );

  var floors = values.map(
    v => Math.floor(v / roundTicksFactor) * roundTicksFactor
  );
  var min = Math.min.apply(null, floors);

  if (min > 0) {
    min = 0;
  }

  var ceilings = values.map(
    v => Math.ceil(v / roundTicksFactor) * roundTicksFactor
  );
  var max = Math.max.apply(null, ceilings);

  var yScale = d3
    .scaleLinear()
    .domain([min, max])
    .range([chartHeight, 0]);

  var chartElement = containerElement
    .append("svg")
    .attr("role", "img")
    .attr("aria-label", "A chart of showing herding decreasing from 50% to 28% across Mongolia")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 axes.

  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .ticks(ticksX)
    .tickFormat(function(d, i) {
      if (isMobile.matches) {
        return "\u2019" + fmtYearAbbrev(d);
      } else {
        return fmtYearFull(d);
      }
    });

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(d => d + "%");

  // Render axes to chart.

  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement
    .append("g")
    .attr("class", "y axis")
    .call(yAxis);

  // Render lines to chart.
  var line = d3
    .line()
    .x(d => xScale(d[dateColumn]))
    .y(d => yScale(d[valueColumn]));

  chartElement
    .append("g")
    .attr("class", "lines")
    .selectAll("path")
    .data(dataSeries)
    .enter()
    .append("path")
    .attr("class", d => "line " + classify(d.name))
    .attr("d", d => line(d.values));

  var lastItem = d => d.values[d.values.length - 1];

  chartElement
    .append("g")
    .selectAll("text")
    .data(dataSeries)
    .enter()
    .append("text")
    .attr("class", function(d){
      var c = "value";
      if(d.name == "Mongolia") c += " bold";
      return c;
    })
    .attr("x", d => xScale(lastItem(d)[dateColumn]) + 5)
    .attr("y", d => yScale(lastItem(d)[valueColumn]))
    .text(function(d) {
      var item = lastItem(d);
      var value = item[valueColumn];
      var label = value.toFixed(1) + "%";

      label = d.name + " (total): " + label;
      if (d.name == "Mongolia") return label;
      if(d.name == "Ulaanbaatar") {
        label = d.name; 
        return label;
      }
    })
    .call(wrapText, 85, 13);

  var annotation = chartElement.append("g").attr("class", "value");

  annotation
    .append("text")
    .text("Herding remains the primary occupation in many rural provinces.")
    .attr("x", function(){
      var x = xScale(new Date(2018, 0, 1)) + 10;
      return x;
    })
    .attr("y", function() {
      var y = yScale(65);
      if (isMobile.matches) y = yScale(75);
      return y;
    })
    .attr("dx", -5)
    .call(wrapText, 85, 13);
}
